import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import Page from '../../components/Page';
import { SearchBar } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';

import { Header, Results } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));

export const VisitorList = withRouter(() => {
  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const [totalcount, setTotalcount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchText, setSearchText] = useState('');
  const { sendNetworkRequest } = React.useContext(NetworkContext);

  useEffect(() => {
    async function load() {
      const bodycontent = {
        searchtext: searchText,
        page: page * rowsPerPage,
        limit: rowsPerPage
      };
      const response = await sendNetworkRequest(
        '/admin/getvisitorregistrations',
        {},
        bodycontent,
        false
      );
      if (!response || !response.visitors) {
        setOrders([]);
        setTotalcount(0);
        return;
      }
      setTotalcount(response.visitors.count);
      setOrders(response.visitors.rows || []);
    }
    load();
  }, [page, rowsPerPage, searchText]);

  function handlePageChange(event, newPage) {
    setPage(newPage);
  }

  function handleRowsPerPageChange(event) {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }

  function applySearch(searchcontent) {
    setPage(0);
    setSearchText(searchcontent || '');
  }

  return (
    <Page className={classes.root} title="Registered visitors">
      <Header />
      <SearchBar onSearch={applySearch} />
      <Results
        className={classes.results}
        orders={orders}
        totalcount={totalcount}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onPageLimit={handleRowsPerPageChange}
      />
    </Page>
  );
});

export default VisitorList;
